import React, { useState } from "react";
import styles from "./Panel.module.css";
import { BiChevronDown, BiChevronUp } from "react-icons/bi";
import TextComponent from "../textComponent/TextComponent";

const Panel = (props) => {
  const [isOpen, setIsOpen] = useState(props?.isOpen ? true : false);
  return (
    <div className={styles.mainCon}>
      <div
        className={styles.header}
        onClick={() => {
          !props?.isOpen && setIsOpen(!isOpen);
        }}
      >
        <TextComponent textClass={styles.heading} text={props?.name} />
        {isOpen ? (
          <BiChevronUp className={styles.dropdownIcon} />
        ) : (
          <BiChevronDown className={styles.dropdownIcon} />
        )}
      </div>
      <div
        className={styles.children}
        style={!isOpen ? { display: "none" } : {}}
      >
        {props?.children}
      </div>
    </div>
  );
};

export default Panel;
